import { render } from "./ExcludedGainCategories.vue?vue&type=template&id=aefb5182&ts=true"
import script from "./ExcludedGainCategories.vue?vue&type=script&lang=ts"
export * from "./ExcludedGainCategories.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/garyfang/Documents/Projects/vue/boxing_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__